module.exports = __WEBPACK_EXTERNAL_MODULE_71__;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 71
// module chunks = 0